export enum STEP_NAMES {
  TermsAndConditions = 'TermsAndConditions',
  CompanyData = 'CompanyData',
  EmailValidation = 'EmailValidation',
  ContactData = 'ContactData',
  BusinessSurvey = 'BusinessSurvey',
  CompanyDetails = 'CompanyDetails',
  DistributorsOnBehalf = 'DistributorsOnBehalf',
  CompanyDataSearch = 'CompanyDataSearch',
}

export enum HELPER_STEP_NAMES {
  TermsAndCoditionAccept = 'TermsAndCoditionAccept',
  ResendInvitationToPartner = 'ResendInvitationToPartner',
  ContunueRegistrationMailWasOpened = 'ContunueRegistrationMailWasOpened',
  CheckContactPartnerId = 'CheckContactPartnerId',
  ConfirmCompanyData = 'ConfirmCompanyData',
  NotConfirmCompanyData = 'NotConfirmCompanyData',
  SearchedCompanySelect = 'SearchedCompanySelect',
  SubmitRegistration = 'SubmitRegistration',
}
